import Color from "color";
import { keyframes } from "styled-components";
import { themeColors } from "./colors";

const hexToRgba = (hex, opacity) =>
  Color(hex)
    .alpha(opacity)
    .string();

export const layers = {
  game: 0,
  settings: 5,
  dialog: 10,
  activity: 15,
  uiBlocker: 9
};

export const activity = {
  backgroundColor: hexToRgba(themeColors.primaryDark, 0.8)
};

export const gameSettings = {
  text: {
    color: themeColors.analogousLight,
    active: themeColors.secondaryLight,
    disabled: themeColors.disabled
  },
  icon: {
    color: themeColors.analogous
  },
  volume: {
    min: 0,
    max: 100
  }
};

/* Default button */
export const button = {
  color: themeColors.secondaryLight,
  hover: themeColors.analogousLight,
  pressed: themeColors.secondaryDark,
  disabled: themeColors.disabled
};

export const spinControlButton = {
  color: themeColors.secondary,
  hover: themeColors.secondaryDark,
  pressed: themeColors.analogousLight,
  disabled: themeColors.analogous,
  active: themeColors.primaryDark
};

/* TopBar */
export const topBar = {
  backgroundColor: themeColors.primaryDark,
  systemClock: {
    color: themeColors.secondaryLight,
    disabled: themeColors.disabled
  },
  homeIcon: {
    color: themeColors.secondaryLight,
    disabled: themeColors.disabled
  },
  pluginMenuIcon: {
    color: themeColors.secondaryLight,
    disabled: themeColors.disabled
  },
  soundActiveIcon: {
    color: themeColors.secondaryLight
  },
  soundInactiveIcon: {
    disabled: themeColors.disabled
  }
};

/* Spinbutton */
export const spinButton = {
  foreground: {
    color: themeColors.primaryDark,
    hover: themeColors.primaryLight,
    pressed: themeColors.analogousLight,
    disabled: themeColors.disabled
  },
  background: {
    color: themeColors.secondaryLight,
    hover: themeColors.secondaryDark,
    pressed: themeColors.secondaryDark,
    disabled: themeColors.secondary
  }
};

export const settingToggle = {
  background: {
    color: themeColors.analogous,
    hover: themeColors.analogousLight,
    pressed: themeColors.analogous,
    active: themeColors.complementaryOnPrimary,
    disabled: themeColors.primaryLight
  },
  button: {
    color: themeColors.secondary,
    hover: themeColors.secondary,
    pressed: themeColors.secondary,
    active: themeColors.secondary,
    disabled: themeColors.analogous
  }
};

export const slider = {
  backgroundColor: hexToRgba(themeColors.primaryDark, 0.5),
  value: {
    color: themeColors.onPrimary
  },
  trackStyle: {
    backgroundColor: themeColors.complementaryOnPrimary
  },
  handleStyle: {
    backgroundColor: themeColors.secondary
  },
  railStyle: {
    backgroundColor: themeColors.primaryLight
  }
};

export const autoplayButton = {
  background: {
    color: themeColors.primaryDark,
    hover: hexToRgba(themeColors.primaryDark, 0.5),
    pressed: themeColors.primaryDark,
    disabled: themeColors.primary
  },
  icon: {
    color: themeColors.secondary,
    hover: themeColors.secondaryLight,
    pressed: themeColors.analogousLight,
    disabled: themeColors.disabled
  },
  text: {
    color: themeColors.primaryDark,
    hover: hexToRgba(themeColors.primaryDark, 0.5),
    pressed: themeColors.primaryDark,
    disabled: themeColors.primary
  }
};

export const autoplayButtonMinimal = {
  icon: {
    color: themeColors.primaryDark,
    hover: themeColors.primaryDark,
    pressed: themeColors.primaryDark,
    disabled: themeColors.primary
  },
  text: {
    color: themeColors.secondary,
    hover: themeColors.secondaryLight,
    pressed: themeColors.analogousLight,
    disabled: themeColors.disabled
  }
};

export const menu = {
  navButton: {
    color: themeColors.analogous,
    hover: themeColors.secondaryLight,
    pressed: themeColors.analogous,
    disabled: themeColors.disabled,
    active: themeColors.secondaryLight,
    activeIndicator: {
      color: themeColors.secondaryLight
    }
  }
};

export const autoplaySettings = {
  border: {
    color: themeColors.onPrimary,
    disabled: themeColors.disabled,
    invalid: themeColors.error,
    valid: themeColors.success
  },
  text: {
    color: hexToRgba(themeColors.secondaryDark, 0.5),
    disabled: themeColors.disabled,
    background: hexToRgba(themeColors.secondaryDark, 0.5),
    active: themeColors.secondaryLight,
    invalid: themeColors.error
  }
};

export const betSettingsWindow = {
  backgroundColor: "transparent",
  header: {
    backgroundColor: themeColors.primaryDark
  },
  content: {
    backgroundColor: hexToRgba(themeColors.primaryDark, 1)
  },
  closeButton: {
    color: themeColors.onPrimary
  },
  overlay: {
    backgroundColor: hexToRgba(themeColors.primaryDark, 0.5)
  }
};

export const settingsWindow = {
  backgroundColor: hexToRgba(themeColors.primaryDark, 1),
  title: {
    color: themeColors.onPrimary
  },
  subtitle: {
    color: hexToRgba(themeColors.onPrimary, 0.6)
  },
  content: {
    backgroundColor: "transparent"
  },
  closeButton: {
    color: themeColors.onPrimary,
    hover: themeColors.secondaryDark,
    pressed: themeColors.secondaryLight,
    backgroundColor: themeColors.primary
  },
  autoplayStartButton: {
    color: themeColors.complementaryOnPrimary,
    hover: themeColors.complementaryOnPrimary,
    pressed: themeColors.complementaryOnPrimary,
    backgroundColor: themeColors.primary,
    disabled: themeColors.disabled
  },
  navigationButton: {
    color: themeColors.onPrimary,
    hover: themeColors.onPrimary,
    pressed: themeColors.onPrimary
  }
};

export const settingButton = {
  color: themeColors.onPrimary,
  hover: hexToRgba(themeColors.onPrimary, 0.3),
  pressed: themeColors.primary,
  disabled: themeColors.disabled,
  selected: themeColors.primary,
  background: {
    color: "transparent",
    hover: "transparent",
    pressed: themeColors.secondary,
    disabled: "transparent",
    selected: themeColors.secondaryLight
  },
  border: {
    color: hexToRgba(themeColors.onPrimary, 0.6),
    hover: hexToRgba(themeColors.onPrimary, 0.3),
    pressed: themeColors.onPrimary,
    disabled: themeColors.disabled,
    selected: themeColors.onPrimary
  }
};

export const displays = {
  color: themeColors.onPrimary,
  backgroundColor: "transparent",
  value: {
    color: themeColors.onPrimary
  },
  title: {
    textShadow: "none"
  }
};

export const tickerDisplay = {
  color: themeColors.secondaryLight,
  linkColor: themeColors.complementaryOnPrimary
};

export const header = {
  backgroundColor: "transparent",
  systemClock: {
    color: themeColors.primary
  },
  homeIcon: {
    color: themeColors.primary,
    disabled: themeColors.disabled
  },
  pluginMenuIcon: {
    color: themeColors.primary,
    disabled: themeColors.disabled
  }
};

export const footer = {
  color: hexToRgba(themeColors.secondaryDark, 0.5),
  backgroundColor: hexToRgba(themeColors.primaryDark, 0.6)
};

export const butterfly = {
  backgroundColor: "transparent"
};

export const keypad = {
  backgroundColor: "transparent",
  icons: {
    backgroundColor: hexToRgba(themeColors.secondaryLight, 0.2),
    color: themeColors.secondaryLight
  }
};

export const dialogs = {
  backgroundColor: themeColors.secondary,
  coverBackgroundColor: themeColors.primaryDark,
  overlayColor: hexToRgba(themeColors.primaryDark, 0.8),
  buttons: {
    primary: {
      color: themeColors.secondaryLight,
      border: "none",
      backgroundColor: themeColors.complementaryOnSecondary
    },
    secondary: {
      color: themeColors.primaryLight,
      border: `1px solid ${themeColors.analogousLight}`,
      backgroundColor: "transparent"
    }
  },
  title: {
    color: themeColors.primary
  },
  content: {
    color: themeColors.primaryLight
  },
  link: {
    color: themeColors.complementaryOnPrimary
  }
};

export const uiBlocker = {
  overlayColor: hexToRgba(themeColors.primaryDark, 0.8)
};

export const playForFun = {
  loopVisibility: keyframes`
    0% {
      opacity: 0;
      pointer-events: none;
    }

    49% {
      opacity: 0;
      pointer-events: none;
    }

    51% {
      opacity: 1;
      pointer-events: all;
    }

    75% {
      opacity: 1;
      pointer-events: all;
    }
  `
};

export const betButton = {
  color: themeColors.secondary,
  hover: themeColors.secondaryDark,
  pressed: themeColors.analogousLight,
  disabled: themeColors.analogous,
  active: themeColors.secondary
};

export const betSliderTrack = {
  backgroundColor: themeColors.complementaryOnPrimary
};

export const paytableButton = {
  color: themeColors.secondary,
  hover: themeColors.secondaryDark,
  pressed: themeColors.analogousLight,
  disabled: themeColors.analogous,
  active: themeColors.secondary
};
